/**
 * ElasticService for Embrilliance static page.
 * Dedicated service with only the methods needed by embrillianceController.
 * Named separately from products elasticService and cart embrillianceElasticService.
 */
storefrontApp.service('embrilliancePageElasticService', function () {

    //#region Embrilliance Starter Packs by Definition (FontPack, DesignPack, ProjectPack)
    this.buildEmbrillianceProductsRequest = function (size, definitionNames) {
        size = size || 8;
        definitionNames = definitionNames || ["Software"];
        
        var mustArray = [
            '{"term":{"brand":"briton leap"}}',
            '{"term":{"inStock":true}}',
            '{"range":{"listPrice":{"gt":0}}}'
        ];

        // Add definition name filter if provided
        if (definitionNames && definitionNames.length > 0) {
            var prdDefObj = [];
            definitionNames.forEach(function (def) {
                prdDefObj.push({
                    "term": {
                        "definitionName": def
                    }
                });
            });
            
            if (prdDefObj.length === 1) {
                // Single definition - add directly to must
                mustArray.push(JSON.stringify(prdDefObj[0]));
            } else if (prdDefObj.length > 1) {
                // Multiple definitions - use should clause
                mustArray.push('{"bool":{"should":' + JSON.stringify(prdDefObj) + ',"minimum_should_match":1}}');
            }
        }

        return (
            '{"query":{"bool":{' +
            '"must":[' + mustArray.join(',') + ']' +
            '}},"size":' + size + ',"sort":[{"saleRank":{"order":"desc"}},{"rating":{"order":"desc"}}],' +
            '"_source":{"includes":["brand","catalog","name","listPrice","salePrice","clubPrice","itemId","variants.variantId","variants.numberOfDesigns","isBuyable","definitionName","rating","saleRank","yearCreated","videoParts","runTime"]}}'
        );
    };

    this.buildEmbrillianceStarterPacksRequest = function (size, definitionNames) {
        size = size || 6;
        var mustArray = [
            '{"term":{"categoriesList.keyword":"embrilliance starter packs"}}',
            '{"term":{"inStock":true}}',
            '{"range":{"listPrice":{"gt":0}}}'
        ];
        if (definitionNames && definitionNames.length > 0) {
            var defTerms = definitionNames.map(function (d) {
                return '{"term":{"definitionName":"' + d + '"}}';
            });
            mustArray.push('{"bool":{"should":[' + defTerms.join(',') + '],"minimum_should_match":1}}');
        }
        return (
            '{"query":{"bool":{"must":[' + mustArray.join(',') + ']}},' +
            '"size":' + size + ',"sort":[{"saleRank":{"order":"desc"}},{"rating":{"order":"desc"}}],' +
            '"_source":{"includes":["brand","catalog","name","listPrice","salePrice","clubPrice","itemId","variants.variantId","variants.numberOfDesigns","isBuyable","definitionName","rating","saleRank","yearCreated","videoParts","runTime"]}}'
        );
    };

    // Category + single definition (e.g. FontPack, DesignPack, ProjectPack) — used by Embrilliance page and home
    this.buildEmbrillianceStarterPacksByDefinitionRequest = function (categoryKeyword, definitionName, size) {
        size = size || 20;
        var query = {
            "query": {
                "bool": {
                    "must": [
                        { "term": { "categoriesList.keyword": categoryKeyword } },
                        { "term": { "definitionName": definitionName } },
                        { "term": { "inStock": true } },
                        { "range": { "listPrice": { "gt": 0 } } }
                    ]
                }
            },
            "size": size,
            "sort": [
                { "saleRank": { "order": "desc" } },
                { "rating": { "order": "desc" } }
            ],
            "_source": {
                "includes": [
                    "brand", "catalog", "name", "listPrice", "salePrice", "clubPrice",
                    "itemId", "variants", "isBuyable",
                    "definitionName", "rating", "saleRank", "yearCreated", "videoParts", "runTime",
                    "fontType", "productId", "categoriesList", "designKeywords"
                ]
            }
        };
        return JSON.stringify(query);
    };
    //#endregion

    //#region Product Info by IDs (for Beginner Designs)
    this.buildProductInfoRequest = function (productId, hasMultiple) {
        if (hasMultiple && angular.isArray(productId)) {
            var req = {
                query: {
                    terms: {
                        _id: []
                    }
                },
                _source: {
                    includes: [
                        "brand", "catalog", "name", "listPrice", "salePrice", "clubPrice",
                        "itemId", "variants", "isBuyable",
                        "definitionName", "rating", "saleRank", "yearCreated", "designKeywords"
                    ]
                }
            };
            productId.forEach(function (m) {
                req.query.terms._id.push((m || '').toLowerCase());
            });
            return JSON.stringify(req);
        }
        return JSON.stringify({
            query: {
                terms: {
                    _id: [productId]
                }
            }
        });
    };
    //#endregion

});
